import React from "react";
import { DateTime } from "luxon";
import { spanishMonths, getYears, getDaysInMonth } from "./calendario/utils";

const dtSelectBase = `
  appearance-none rounded-lg border border-zinc-950/10
  bg-white px-2 py-1.5 text-sm text-zinc-950 shadow-sm
  transition-colors focus:border-zinc-950/10 focus:outline-none focus:ring-none
  dark:border-white/10 dark:bg-white/5 dark:text-white w-full
`;
const dtSelectWrap = `
  relative after:pointer-events-none after:absolute after:right-2
  after:top-[50%] after:h-2 after:w-2 after:translate-y-[-50%]
  after:rotate-45 after:border-r-2 after:border-b-2
  after:border-zinc-500 after:content-[''] dark:after:border-zinc-400
`;

const DateTimeDropdowns = ({ label, value, onChange }) => {
  let dt = DateTime.fromFormat(value || "", "yyyy-LL-dd'T'HH:mm");
  if (!dt.isValid) dt = DateTime.fromISO(value || "");
  if (!dt.isValid) dt = DateTime.now();

  const fire = (changes) => onChange(dt.set(changes).toFormat("yyyy-LL-dd'T'HH:mm"));

  return (
    <div>
      {label && (
        <div className="text-xs font-medium text-zinc-500 dark:text-zinc-400 mb-1">{label}</div>
      )}
      <div className="grid grid-cols-7 sm:grid-cols-12 gap-1.5">
        <div className={`col-span-1 sm:col-span-2 ${dtSelectWrap}`}>
          <select
            className={`${dtSelectBase} pr-6`}
            value={dt.day}
            onChange={(e) => fire({ day: parseInt(e.target.value) })}
          >
            {Array.from({ length: getDaysInMonth(dt.year, dt.month - 1) }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>
        <div className={`col-span-2 sm:col-span-3 ${dtSelectWrap}`}>
          <select
            className={`${dtSelectBase} pr-6`}
            value={dt.month - 1}
            onChange={(e) => fire({ month: parseInt(e.target.value) + 1 })}
          >
            {spanishMonths.map((m, i) => (
              <option key={m} value={i}>
                {m}
              </option>
            ))}
          </select>
        </div>
        <div className={`col-span-2 sm:col-span-3 ${dtSelectWrap}`}>
          <select
            className={`${dtSelectBase} pr-6`}
            value={dt.year}
            onChange={(e) => fire({ year: parseInt(e.target.value) })}
          >
            {getYears().map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
        <div className={`col-span-1 sm:col-span-2 ${dtSelectWrap}`}>
          <select
            className={`${dtSelectBase} pr-6`}
            value={dt.hour}
            onChange={(e) => fire({ hour: parseInt(e.target.value) })}
          >
            {Array.from({ length: 24 }, (_, i) => (
              <option key={i} value={i}>
                {String(i).padStart(2, "0")}
              </option>
            ))}
          </select>
        </div>
        <div className={`col-span-1 sm:col-span-2 ${dtSelectWrap}`}>
          <select
            className={`${dtSelectBase} pr-6`}
            value={dt.minute}
            onChange={(e) => fire({ minute: parseInt(e.target.value) })}
          >
            {Array.from({ length: 12 }, (_, i) => i * 5).map((m) => (
              <option key={m} value={m}>
                {String(m).padStart(2, "0")}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default DateTimeDropdowns;
